/**
 * Created with JetBrains WebStorm.
 * User: vanessaSoc
 * Date: 26/04/19
 * Time: 09:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('DialogLevel3DCtrl', ["$scope", "$rootScope", "dialog", "dialogsModel",
    function ($scope, $rootScope, dialog, dialogsModel)
    {
        let key;
        // hook the passed data to the popin scope
        for (key in dialogsModel) {
            $scope[key] = dialogsModel[key];
        }
        $scope.dd = {
            level: "" + $scope.companyView.level3ds + ""
        };
        $scope.dialog = dialog;
        $scope.cancel = function(){
            $scope.onCloseWindow();
            dialog.close(false);
        };
        $scope.action = function(){
            $scope.onCloseWindow();
            dialog.close(true);
        };
        $scope.onCloseWindow = function(){
            if(!isNaN($scope.dd.level))
                $scope.companyView.level3ds = parseInt($scope.dd.level);

        };

    }]);


// WEBPACK FOOTER //
// ./js/controllers/pro/dialog/DialogLevel3DCtrl.js